'use strict';

/* global yith_wcaf */

import YITH_WCAF_Admin_Table from './yith-wcaf-admin-table';
import YITH_WCAF_Admin_Modal from './yith-wcaf-admin-modal';
import { $, confirm } from '../../../src/globals.js';

export default class YITH_WCAF_Admin_Actions_Table extends YITH_WCAF_Admin_Table {
	// modal
	modal = null;

	init() {
		this.initModal();
		this.initDragNDrop();
		this.initCloneButtons();
		this.initDeleteButtons();
		this.initEnableButtons();
		this.initRestoreDefaultButton();
	}

	initCloneButtons() {
		const self = this;

		this.$context.on( 'click', '.clone a', function ( ev ) {
			ev.preventDefault();

			self.doButtonAction( 'clone', $( this ) );
		} );
	}

	initDeleteButtons() {
		const self = this;

		this.$context.on( 'click', '.delete a', function ( ev ) {
			ev.preventDefault();

			confirm().then( () => {
				self.doButtonAction( 'delete', $( this ), ( $row ) =>
					$row.remove()
				);
			} );
		} );
	}

	initEnableButtons() {
		const self = this;

		this.$context.on(
			'change',
			'.enabled input[type="checkbox"]',
			function ( ev ) {
				ev.preventDefault();

				const $field = $( this ),
					action = $field.is( ':checked' ) ? 'enable' : 'disable';

				self.doButtonAction( action, $field );
			}
		);
	}

	initModal() {
		const $openers = this.getModalOpeners();

		if ( $openers.length ) {
			this.modal = new YITH_WCAF_Admin_Modal( $openers );
		}
	}

	initDragNDrop() {
		this.$table.find( 'tbody' ).sortable( {
			handle: '.drag',
			update: () => {
				const $rows = this.$table.find( 'tbody' ).find( 'tr' ),
					rows = $rows.get(),
					order = rows.map( ( item ) =>
						item.getAttribute( 'data-id' )
					);

				this.doAjax(
					`sort${ this.args?.action_suffix }s`,
					`sort${ this.args?.nonce_suffix }s`,
					{
						order,
					}
				);
			},
		} );
	}

	initRestoreDefaultButton() {
		$( '#restore_defaults', this.$context ).on( 'click', ( ev ) => {
			ev.preventDefault();

			this.doAjax(
				`restore_default${ this.args?.action_suffix }s`,
				`restore${ this.args?.nonce_suffix }s`,
				null,
				( data ) => {
					if ( data?.template ) {
						this.replaceTable( data.template );
					}
				}
			);
		} );
	}

	getModalOpeners() {
		return $( '.edit', this.$table )
			.add( '#add_field', this.$context )
			.add( '.yith-add-button', this.$context );
	}

	refreshModalOpeners() {
		this.modal.addOpeners( this.getModalOpeners() );
	}

	replaceTable( newTable ) {
		super.replaceTable( newTable );

		// register new modal openers
		this.initModal();

		// re-init drag&Drop
		this.initDragNDrop();
	}
}
